import { isEmpty } from "lodash";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthProvider from "../../context/AuthContext";
import BetSlipContext from "../../context/BetSlipContext";
import helpers from "../../Utils/helpers";
import MatchDetails from "../MatchDetails/MatchDetails";
import BackandLay from "../MatchDetails/BackandLay";
import MatchDetailsHome from "../MatchDetails/MatchDetailsHome";
import BackandLayHome from "../MatchDetails/BackandLayHome";
import useOddsDataStore from "../../Utils/zustand/OddsStore";

const InplayTabs = ({
  data,
  type,
  sportsType,
  sportsId,
  handelAddMultiMarket,
  setLoading,
  parlyTab,
  showPin = true,
  desktop = false,
  desktopHeadings = false,
  homeBadges = false,
  cricketBadges = false,
}) => {
  let { user, profileData, setSearchToogle, setCasinoModel, setCasinoObj, launchCasino, inPlayScore } = useContext(AuthProvider); // Get inPlayScore from context
  let { handelAddMultiMarket: handelAddMultiMarketBetSlip } = useContext(BetSlipContext);

  const oddsData = useOddsDataStore((state) => state.oddsData);

  const navigate = useNavigate();

  const [slipObj, setSlipObj] = useState({});
  const [selectedBet, setSelectedBet] = useState({
    selectionId: "",
    teamName: "",
    check: "",
  });
  const [key, setKey] = useState("");
  const [betType, setBetType] = useState("betFair");
  const [condi, setCondi] = useState(false);
  const [messaageBox, setMessaageBox] = useState(false);

  const amountRange = {
    min: import.meta.env.VITE_AMOUNT_RANGE_MIN
      ? Number(import.meta.env.VITE_AMOUNT_RANGE_MIN)
      : 1,
    max: import.meta.env.VITE_AMOUNT_RANGE_MAX
      ? Number(import.meta.env.VITE_AMOUNT_RANGE_MAX)
      : 100,
    oddsLimit: 1000,
  };

  const resetSelection = (type) => {
    // Reset selection logic
  };

  // Normalizes different backend formats (on/true/1/yes) to a boolean for badge display
  const isBadgeOn = (...values) =>
    values.some(
      (v) =>
        v === "on" ||
        v === true ||
        v === 1 ||
        v === "1" ||
        v === "yes" ||
        v === "true"
    );

  const handelBetFairPositions = (data) => {
    // Handle bet fair positions
  };

  // Update data with score from context
  const updatedData = data?.map((item) => {
    let temp = inPlayScore?.find((score) => String(score?.eventId) === String(item?.eventId)); // Ensure string comparison
    if (temp) {
      return {
        ...item,
        score: temp?.current_score || "", // Use current_score from the score object
        timeElapsed: temp?.timeElapsed || "", // Also update timeElapsed if available
      };
    }
    return item;
  });

  const firstVisibleItem = updatedData?.find(item => item.eventType == sportsId);
  const useCricketBadges = cricketBadges && sportsId == 4;
  const badgeOrder = useCricketBadges ? ["F", "S", "BM"] : ["BM", "F", "S"];
  // Home's badge sequence is presentation-only; market flags remain unchanged.
  const renderRowBadges = item => (
    <div className={`home-match-badges${useCricketBadges ? " inplay-cricket-badges" : ""}`}>
      {(item === firstVisibleItem ? ["S"] : badgeOrder).map(badge => (
        <span key={badge} className={`home-match-badge home-match-badge-${badge.toLowerCase()}`}>
          {badge}
        </span>
      ))}
    </div>
  );

  useEffect(() => {
    if (oddsData && Object.keys(oddsData).length > 0) {
      const filtered = updatedData.filter((item) => { // Use updatedData here
        const eventId = Object.keys(oddsData)[0];
        return item.eventId == eventId;
      });
    }
  }, [oddsData, updatedData]); // Depend on updatedData

  if (desktop) {
    const desktopRows = updatedData.filter(item => item.eventType == sportsId);
    return (
      <div className="desktop-sport-block">
        {desktopHeadings && desktopRows.length > 0 && (
          <>
            <h3 className="desktop-sport-title">{sportsType}</h3>
            <div className="desktop-odds-head" aria-hidden="true"><span /><span>1</span><span>X</span><span>2</span><span /></div>
          </>
        )}
      <div className="desktop-match-list" aria-label={`${sportsType} matches`}>
        {desktopRows.map(item => {
          const market = item.desktopMarket;
          const selections = market?.selections || item.desktopSelections || [];
          const nameOf = selection => selection?.runnerName || item.runners?.find(runner => String(runner.SelectionId) === String(selection?.selectionId))?.RunnerName || "";
          const draw = selections.find(selection => /^(the )?draw$|^tie$/i.test(nameOf(selection).trim()));
          const teams = selections.filter(selection => selection !== draw);
          const ordered = [teams[0], draw, teams[1]];
          const matchPath = `/match-details/${item.eventId}/${item.marketId}`;
          const priceOf = (selection, side) => {
            if (market && market.status !== "OPEN") return 0;
            if (selection?.status && selection.status !== "ACTIVE") return 0;
            const value = Number(selection?.[side]?.[0]?.price);
            return Number.isFinite(value) && value > 0 ? value : 0;
          };
          return (
            <div className="desktop-match-row" key={item.eventId}>
              <div className="desktop-match-info">
                <Link to={matchPath} state={item} className="desktop-match-name">
                  <strong>{item.eventName}</strong>
                  {item.status === "in_play"
                    ? <span className="desktop-match-live">In-Play</span>
                    : <time dateTime={item.eventDateTime}>{moment(item.eventDateTime).format("DD-MM-YYYY HH:mm")}</time>}
                </Link>
                <div className="desktop-match-badges">
                  {(homeBadges || useCricketBadges) ? renderRowBadges(item) : (
                    <>
                      {isBadgeOn(item.bookMaker, item.bookmaker, item.isBookmakers, item.isBookmaker) && <span className="desktop-badge-bm">BM</span>}
                      {isBadgeOn(item.fancy, item.isFancy) && <span className="desktop-badge-f">F</span>}
                      {isBadgeOn(item.premiumFancy, item.sportBook, item.sportsBook, item.isSportsbook, item.premium) && <span className="desktop-badge-s">S</span>}
                    </>
                  )}
                </div>
              </div>
              {ordered.map((selection, index) => (
                <div className="desktop-odds-pair" key={index}>
                  {["availableToBack", "availableToLay"].map((side, sideIndex) => {
                    const price = priceOf(selection, side);
                    const label = `${sideIndex ? "Lay" : "Back"} ${nameOf(selection) || ["1", "Draw", "2"][index]}: ${price}`;
                    return price > 0 ? (
                      <Link key={side} to={matchPath} state={item} className={sideIndex ? "desktop-lay" : "desktop-back"} aria-label={label}>{price}</Link>
                    ) : <span key={side} className={sideIndex ? "desktop-lay" : "desktop-back"} aria-label={label}>0</span>;
                  })}
                </div>
              ))}
              {showPin && <button type="button" className={`desktop-match-pin ${item.multi_market > 0 ? "is-pinned" : ""}`} aria-label={`Pin ${item.eventName}`} onClick={() => {
                if (!isEmpty(user)) { handelAddMultiMarket(item.eventId); setLoading(true); }
                else navigate("/login");
              }}>
                <svg width="23" height="23" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="none" stroke="currentColor" /><path d="M8 4h8l-1 2v4l4 4v1h-6v6h-2v-6H5v-1l4-4V6z" fill="currentColor" /></svg>
              </button>}
            </div>
          );
        })}
      </div>
      </div>
    );
  }

  return (
    <div className="wrap-highlight_list" id="inPlayData">
      <style>{`
        @keyframes inplayColorLoop {
          0%   { color: #d32f2f; }
          50%  { color: #508d0e; }
          100% { color: #d32f2f; }
        }
        .inplay-blink {
          animation: inplayColorLoop 0.8s ease-in-out infinite;
        }
      `}</style>
      <div id="inPlayEventType_4" style={{ display: "block" }}>
        <h3 className="inppayTitle">{sportsType}</h3>
        {/* {sportsType == "Cricket" ? (
          <div className="game_ban">
            <img
              src={
                
                "/assets/images/home/cricketnewbanner.webp"
              }
              alt=""
            />
          </div>
        ) : sportsType == "Tennis" ? (
          <div className="game_ban">
            <img
              src={
                
                "/assets/images/home/tennisnewbanner.webp"
              }
              alt=""
            />
          </div>
        ) : (
          sportsType == "Soccer" && (
            <div className="game_ban">
              <img
                src={
                  
                  "/assets/images/home/soccernewbanner.webp"
                }
                alt=""
              />
            </div>
          )a
        )} */}
        <ul className="highlight-list" style={{marginBottom:"0"}} id="inPlayList_4">
          {updatedData.length > 0 && // Use updatedData here
            updatedData.map((item, index) => { // Use updatedData here
              let filtered = updatedData.filter((oddItem) => oddItem.eventId == item.eventId); // Use updatedData here
              let obj = moment.duration(
                moment(item?.eventDateTime).diff(moment(new Date()))
              )?._data;
              const homeScheduledRow = homeBadges && item.status !== "in_play";
              return (
                item.eventType == sportsId && (
                  <>
                  <li
                    id="inPlayEvent_-10362833"
                    key={index}
                    className={`inplay-match-row inplay-on ${
                      type == "inplay" ? "inplay-dot-true" : "inplay-dot-false"
                    }`}
                    style={{
                      display: 'flex',
                      alignItems: 'stretch',
                      padding: '3px 8px 3px 8px',
                      borderBottom: '1px solid #e0e0e0',
                      backgroundColor: '#fff',
                      width: '100%',
                      boxSizing: 'border-box',
                    }}
                  >
                    {/* Left: Match Name + Status (wraps) */}
                    <Link
                      id="info"
                      className="inplay-match-link"
                      to={`/match-details/${item.eventId}/${item.marketId}`}
                      state={item}
                      style={{
                        flex: 1,
                        textDecoration: 'none',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        gap: '2px',
                        textAlign: 'left',
                        alignItems: 'flex-start',
                        ...(homeScheduledRow
                          ? { paddingTop: '3px', paddingBottom: '3px', paddingRight: 0 }
                          : { paddingRight: '8px' }),
                        paddingLeft: homeBadges ? 0 : undefined,
                        minWidth: 0,
                      }}
                    >
                      <div style={{
                        fontSize: 'var(--inplay-match-font-size, 15.72px)',
                        lineHeight: 'var(--inplay-match-line-height, 1.4)',
                        width: '100%',
                        maxWidth: '100%',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        overflowWrap: 'break-word',
                      }}>
                        <span style={{
                          color: '#2789CE',
                          fontWeight: '700',
                          fontFamily: 'Tahoma, Helvetica, sans-serif',
                          display: homeScheduledRow ? 'inline' : undefined,
                          maxWidth: '100%',
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                        }}>
                          {(() => {
                            const parts = item?.eventName?.split(/\s+v\s+/i);
                            const team1 = parts?.[0] || item?.eventName;
                            const team2 = parts?.[1] || "";
                            
                            if (item?.score) {
                              return team2 ? (
                                <>
                                  {team1}
                                  <span style={{ color: '#e4550f', fontWeight: "700" }}>
                                    {" " + (item?.score?.split(" || ")[0] || item?.score) + " "}
                                  </span>
                                  {team2}
                                </>
                              ) : (
                                <>
                                  {item?.eventName}
                                  <span style={{ color: '#e4550f', fontWeight: "700" }}>
                                    {" " + (item?.score?.split(" || ")[0] || item?.score)}
                                  </span>
                                </>
                              );
                            } else {
                              return team2 ? (
                                <>
                                  {team1}
                                  <span style={{ color: "#2789CE", fontWeight: "700" }}> v </span>
                                  {team2}
                                </>
                              ) : (
                                item?.eventName
                              );
                            }
                          })()}
                        </span>
                        {item.status == "in_play" && (
                          <span className="inplay-blink" style={{
                            fontSize: '12px',
                            fontWeight: '700',
                            fontFamily: 'Tahoma, Helvetica, sans-serif',
                            marginLeft: '6px',
                            whiteSpace: 'nowrap',
                          }}>
                            In-Play
                          </span>
                        )}
                        {homeScheduledRow && " "}
                        {item.status !== "in_play" && (
                          <span style={{
                            color: '#666',
                            fontSize: '12px',
                            fontWeight: '400',
                            fontFamily: 'Tahoma, Helvetica, sans-serif',
                            display: homeScheduledRow ? 'inline-block' : undefined,
                            marginLeft: homeScheduledRow ? 0 : '8px',
                            whiteSpace: 'nowrap',
                          }}>
                            {moment(item.eventDateTime).format("MM-DD-YYYY H:mm")}
                          </span>
                        )}
                      </div>
                    </Link>
                    {/* Right: Badges + Pin (fixed, centered vertically) */}
                    <div className="inplay-match-actions" style={{ display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0, paddingLeft: '8px' }}>
                      {(homeBadges || useCricketBadges) ? renderRowBadges(item) : (
                        <>
                      {isBadgeOn(item?.bookMaker, item?.bookmaker, item?.isBookmakers, item?.isBookmaker) && (
                        <span style={{
                          backgroundColor: '#1565c0',
                          color: '#fff',
                          fontSize: '11px',
                          fontWeight: '700',
                          padding: '3px 6px',
                          borderRadius: '4px',
                          fontFamily: 'Tahoma, Helvetica, sans-serif',
                        }}>
                          BM
                        </span>
                      )}
                      {isBadgeOn(item?.fancy, item?.isFancy) && (
                        <span style={{
                          backgroundColor: '#00897b',
                          color: '#fff',
                          fontSize: '11px',
                          fontWeight: '700',
                          padding: '3px 6px',
                          borderRadius: '4px',
                          fontFamily: 'Tahoma, Helvetica, sans-serif',
                        }}>
                          F
                        </span>
                      )}
                      {isBadgeOn(item?.premiumFancy, item?.sportBook, item?.sportsBook, item?.isSportsbook, item?.premium) && (
                        <span style={{
                          backgroundColor: '#e65100',
                          color: '#fff',
                          fontSize: '11px',
                          fontWeight: '700',
                          padding: '3px 6px',
                          borderRadius: '4px',
                          fontFamily: 'Tahoma, Helvetica, sans-serif',
                        }}>
                          S
                        </span>
                      )}
                        </>
                      )}
                      {showPin && (
                        <a
                          id="multiMarketPin"
                          onClick={() => {
                            if (!isEmpty(user)) {
                              handelAddMultiMarket(item.eventId);
                              setLoading(true);
                            } else {
                              navigate("/login");
                            }
                          }}
                          className={item.multi_market > 0 ? "pin-on" : "pin-off"}
                          href="javascript:void(0)"
                          style={{
                            marginLeft: '8px',
                            ...(homeBadges ? {
                              width: '25px',
                              height: '25px',
                              flex: '0 0 25px',
                              backgroundSize: '25px 25px',
                            } : {}),
                          }}
                        ></a>
                      )}
                    </div>
                  </li>
                  {item?.back_odds && item?.back_odds?.length > 0 && (
                    <MatchDetailsHome
                      selections={item?.runners || []}
                      back_odds={item?.back_odds || []}
                      lay_odds={item?.lay_odds || []}
                      details={item}
                      totalMatched={item?.totalMatched || 0}
                      setSlipObj={setSlipObj}
                      setSelections={() => {}}
                      slipObj={slipObj}
                      handelBetFairPositions={handelBetFairPositions}
                      resetSelection={resetSelection}
                      setCondi={setCondi}
                      betType="betFair"
                      profileData={profileData}
                      user={user}
                      messaageBox={messaageBox}
                      betFairMs={item?.matchOddsData?.ms || 1}
                      setMarketDepth={() => {}}
                      marketId={item?.marketId}
                      marketName="Match Odds"
                    />
                  )}
                  {/* {console.log("filteredData", filteredData)} */}
                  </>
                )
              );
            })}

          
        </ul>
        
      </div>
     
    </div>
  );
};

export default InplayTabs;